import { Fragment } from "react";

/**
 * Renders copy where `**Capture Visit**` marks a button label. The labels are bold so a reader
 * scanning the card finds the word they will see on screen.
 */
export default function GuideText({ text }: { text: string }) {
  return (
    <>
      {text
        .split("**")
        .map((part, index) =>
          index % 2 === 1 ? (
            <b key={index}>{part}</b>
          ) : (
            <Fragment key={index}>{part}</Fragment>
          )
        )}
    </>
  );
}
